import { configureStore } from '@reduxjs/toolkit';
import contractReducer from '../redux/slices/reducers';
import userInfoReducer from '../redux/slices/userInfoReducer';
import entitlementReducer from '../redux/slices/EntitlementReducer';
import packageReducer from '../redux/slices/PackageReducer';
import entitlementDetailsReducer from '../redux/slices/EntitlementDetailReducer';
import thunk from 'redux-thunk';
import datasetDetailsReducer from '../redux/slices/DatasetDetailReducer';
import distributorDetailsReducer from '../redux/slices/DistributorDetailsReducer';
import distributorsReducer from '../redux/slices/DistributorsReducer';
import jobFunctionDesignationReducer from '../redux/slices/JobFunctionDesignationReducer';
import entitlementStatusReducer from '../redux/slices/entitlementStatusReducer';
import userGroupEntitlementReducer from '../redux/slices/UserGroupEntitlementReducer';
import userPreferencesReducer from '../redux/slices/UserPreferencesReducer';
import userContractsReducer from '../redux/slices/userContractReducer';
import LocationReducer from '../redux/slices/LocationReducer';
import DbConfigReducer from '../redux/slices/DbConfigReducer';

export const store = configureStore({
  reducer: {
    contract: contractReducer,
    userPreferences: userPreferencesReducer,
    userContracts: userContractsReducer,
    userInfo: userInfoReducer,
    entitlementUsers: entitlementReducer,
    packageDetails: packageReducer,
    jobDesignationDetails: jobFunctionDesignationReducer,
    entitlementStatusDetails: entitlementStatusReducer,
    entitlementDetails: entitlementDetailsReducer,
    datasets: datasetDetailsReducer,
    distributorsDetails: distributorDetailsReducer,
    distributors: distributorsReducer,
    userGroupEntitlement: userGroupEntitlementReducer,
    locationTab: LocationReducer,
    dbConfig: DbConfigReducer,
  },
  middleware: [thunk],
});
export default store;
